import { split } from "./utils"
import gsap from "gsap"
import { CustomEase } from "gsap/CustomEase"

gsap.registerPlugin(CustomEase)

CustomEase.create("customEase", "0.215, 0.61, 0.355, 1")

class Loader {
  constructor({ cb } = {}) {
    this.DOM = this.getDOM()

    this.cb = cb

    this.isMobile = window.innerWidth < 600

    const headline = split({
      contentType: "headline",
      textElement: this.DOM.headline
    })

    this.DOM.headline = headline.lines.map(line => line.querySelectorAll(".line-container"))

    this.tl = this.isMobile ? this.createMobileTween() : this.createTimeline()

  }

  getDOM() {
    return {
      pageCover: document.getElementById("page-cover"),
      mainLogoOverflow: document.querySelector(".navigation__logo-full"),
      mainLogo: document.querySelector(".navigation__logo-full .svg"),
      navLinks: document.querySelectorAll(".navigation__anchor"),
      halfLogoOverflow: document.querySelector(".navigation__logo-half"),
      halfLogo: document.querySelector(".navigation__logo-half .svg"),
      navBorder: document.getElementById("nav-border"),
      headline: document.querySelector(".introduction h1"), // split in the constructor
      imageOverflow: document.getElementById("introduction-image"),
      image: document.querySelector("#introduction-image img"),
    }
  }

  createTimeline() {
    const tl = new gsap.timeline({
      paused: true, onComplete: () => {
        this.cb()

        // gsap.set([
        //   this.DOM.headline,
        //   this.DOM.imageOverflow,
        //   this.DOM.image],
        //   { clearProps: "all" })
      }
    })

    tl
      .fromTo(this.DOM.navBorder, { scaleX: 0 }, { scaleX: 1, duration: 1.2, ease: "Sine.easeInOut" })
      .fromTo(this.DOM.mainLogo, { y: "-100%" }, { y: "0%", duration: 1.2, ease: "customEase" }, "-=1")
      .fromTo(this.DOM.navLinks, { y: "-100%" }, { y: "0%", duration: 1.2, ease: "customEase" }, "-=1")
      .fromTo(this.DOM.halfLogo, { y: "-100%" }, { y: "0%", duration: 1.2, ease: "customEase" }, "-=1")
      .fromTo(this.DOM.headline, { y: "100%" }, { y: "0%", duration: 1.2, ease: "customEase" }, "-=1.25")
      .fromTo(this.DOM.imageOverflow, { y: "100%" }, { y: "0%", duration: 2, ease: "customEase" }, "-=1.5")
      .fromTo(this.DOM.image, { y: "-100%" }, { y: "0%", force3D: true, duration: 2, ease: "customEase" }, "-=2")
      .fromTo(this.DOM.image, { scale: 1.5 }, { scale: 1, force3D: true, duration: 2, ease: "customEase" }, "-=2")

    return tl
  }

  createMobileTween() {
    const tl = new gsap.timeline({ paused: true, onComplete: () => this.cb() })

    tl.fromTo(this.DOM.pageCover, { autoAlpha: 1 }, { autoAlpha: 0, duration: .5 })

    return tl
  }

  play() {
    gsap.fromTo(this.DOM.pageCover, { autoAlpha: 1 }, { autoAlpha: 0, duration: .5 })
    this.tl.progress(0)
    this.tl.play()
  }

}

export default Loader